import { render, staticRenderFns } from "./CashGiftGoodsDetail.vue?vue&type=template&id=00e23e1b&scoped=true&"
import script from "./CashGiftGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./CashGiftGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CashGiftGoodsDetail.vue?vue&type=style&index=0&id=00e23e1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e23e1b",
  null
  
)

export default component.exports